type ReplaceValuesInput = {
  values: unknown[];
  replaceWith?: unknown;
};

type JSONStringifyReplacer = (this: unknown, key: string, value: unknown) => unknown;

export function replaceValuesWith({ values, replaceWith = '' }: ReplaceValuesInput): JSONStringifyReplacer {
  return (key: string, value: unknown) => {
    return values.some(valueToReplace => valueToReplace === value) ? replaceWith : value;
  };
}
